import { filterInternalTags } from '@/utils/filterInternalTags';
import {
  normalizeCustomTags,
  stripCodeErrorTagContent,
  unwrapBacktickedCustomTags,
} from './CustomTagCom';

export { filterInternalTags } from '@/utils/filterInternalTags';

const MARKDOWN_PREPROCESSORS = [
  unwrapBacktickedCustomTags,
  stripCodeErrorTagContent,
  filterInternalTags,
  normalizeCustomTags,
];

/**
 * Markdown 渲染前统一预处理
 */
export function preprocessMarkdownContent(content: string): string {
  return MARKDOWN_PREPROCESSORS.reduce(
    (result, preprocess) => preprocess(result),
    content,
  );
}
